import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { ClockIcon, ArrowLeftIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function ComingSoonPage() {
  const {
    isArabic
  } = useLanguage();
  return <div className="w-full px-6 md:px-10 lg:px-20 py-16" data-id="element-199">
      <div className="max-w-3xl mx-auto text-center" data-id="element-200">
        <div className="mb-8" data-id="element-201">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-blue-100 dark:bg-blue-900/30 rounded-full mb-6" data-id="element-202">
            <ClockIcon className="w-10 h-10 text-blue-600 dark:text-blue-400" data-id="element-203" />
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 dark:text-white mb-4" data-id="element-204">
            {isArabic ? 'قريباً' : 'Coming Soon'}
          </h1>
          <p className="text-xl text-gray-600 dark:text-gray-300" data-id="element-205">
            {isArabic ? 'نحن نعمل بجد لإنشاء هذه الصفحة. ترقبوا!' : "We're working hard to create this page. Stay tuned!"}
          </p>
        </div>
        <div className="bg-white dark:bg-gray-800 rounded-xl shadow-md p-8 mb-8" data-id="element-206">
          <h2 className="text-2xl font-semibold text-gray-900 dark:text-white mb-4" data-id="element-207">
            {isArabic ? 'ماذا يمكنك أن تتوقع؟' : 'What can you expect?'}
          </h2>
          <ul className="space-y-3 text-left" data-id="element-208">
            <li className="flex items-start gap-3" data-id="element-209">
              <div className="p-1 bg-blue-100 dark:bg-blue-900/30 rounded-full mt-1" data-id="element-210">
                <div className="w-2 h-2 bg-blue-600 dark:bg-blue-400 rounded-full" data-id="element-211"></div>
              </div>
              <span className="text-gray-700 dark:text-gray-300" data-id="element-212">
                {isArabic ? 'محتوى تعليمي عالي الجودة مصمم خصيصًا لاحتياجاتك' : 'High-quality educational content tailored to your needs'}
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-213">
              <div className="p-1 bg-blue-100 dark:bg-blue-900/30 rounded-full mt-1" data-id="element-214">
                <div className="w-2 h-2 bg-blue-600 dark:bg-blue-400 rounded-full" data-id="element-215"></div>
              </div>
              <span className="text-gray-700 dark:text-gray-300" data-id="element-216">
                {isArabic ? 'أدوات تفاعلية لمساعدتك على التعلم بشكل أسرع' : 'Interactive tools to help you learn faster'}
              </span>
            </li>
            <li className="flex items-start gap-3" data-id="element-217">
              <div className="p-1 bg-blue-100 dark:bg-blue-900/30 rounded-full mt-1" data-id="element-218">
                <div className="w-2 h-2 bg-blue-600 dark:bg-blue-400 rounded-full" data-id="element-219"></div>
              </div>
              <span className="text-gray-700 dark:text-gray-300" data-id="element-220">
                {isArabic ? 'مجتمع داعم لمساعدتك في رحلة تعلم اللغة' : 'A supportive community to help you in your language learning journey'}
              </span>
            </li>
          </ul>
        </div>
        <Link to="/" className="inline-flex items-center gap-2 px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors" data-id="element-221">
          <ArrowLeftIcon className="w-4 h-4" data-id="element-222" />
          <span data-id="element-223">
            {isArabic ? 'العودة إلى الصفحة الرئيسية' : 'Back to Home'}
          </span>
        </Link>
      </div>
    </div>;
}